module.exports = __webpack_public_path__ + "img/icon-filter.40f07826.svg";